"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = usePostActivity;

var _useWebChatAPIContext = _interopRequireDefault(require("./internal/useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function usePostActivity() {
  return (0, _useWebChatAPIContext.default)().postActivity;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VQb3N0QWN0aXZpdHkudHMiXSwibmFtZXMiOlsidXNlUG9zdEFjdGl2aXR5IiwicG9zdEFjdGl2aXR5Il0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBR0E7Ozs7QUFFZSxTQUFTQSxlQUFULEdBQWlGO0FBQzlGLFNBQU8scUNBQXVCQyxZQUE5QjtBQUNEIiwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBEaXJlY3RMaW5lQWN0aXZpdHkgfSBmcm9tICdib3RmcmFtZXdvcmstd2ViY2hhdC1jb3JlJztcbmltcG9ydCBPYnNlcnZhYmxlIGZyb20gJ2NvcmUtanMvZmVhdHVyZXMvb2JzZXJ2YWJsZSc7XG5cbmltcG9ydCB1c2VXZWJDaGF0QVBJQ29udGV4dCBmcm9tICcuL2ludGVybmFsL3VzZVdlYkNoYXRBUElDb250ZXh0JztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gdXNlUG9zdEFjdGl2aXR5KCk6IChhY3Rpdml0eTogRGlyZWN0TGluZUFjdGl2aXR5KSA9PiBPYnNlcnZhYmxlPHN0cmluZz4ge1xuICByZXR1cm4gdXNlV2ViQ2hhdEFQSUNvbnRleHQoKS5wb3N0QWN0aXZpdHk7XG59XG4iXX0=